// extracted by mini-css-extract-plugin
module.exports = {"box":"Page3_box__3on-D","boxTitle":"Page3_boxTitle__2qabf","labelText":"Page3_labelText__1JErb"};